import ReactOnRails from 'react-on-rails';
import App from 'src/Root';

ReactOnRails.register({
  App
});
